import { computed, makeObservable } from 'mobx'

import type { Model } from 'modules/core/lib/mobx-rest'
import { Collection } from 'modules/core/lib/mobx-rest'

export interface IPayrollLegalEntityResource {
  id: number
  legal_entity_id: number
  name: string
}

export abstract class PayrollLegalEntityResource<T extends Model> extends Collection<T> {
  constructor(data: any = []) {
    super(data)

    makeObservable(this, {
      actives: computed
    })
  }

  get actives() {
    return this.models.filter((model: any) => model.isActive)
  }
}
